// NPM
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

// Components
import Snackbar from 'components/snackbar/Snackbar';

// Utilities and Services
import { setSnackBar, removeSnackBar } from '../../logic/store/snackbar/actions';

const snackbarTimeout = 5000;

export const SnackbarMgr = ({ dataQa, messages, zIndex }) => {
  const dispatch = useDispatch();
  const dispatchSnackBarMessage = ({ message, type, uid }) =>
    dispatch(setSnackBar({ uid, message, type }));
  const dispatchSnackBarMessageRemove = (id) => dispatch(removeSnackBar(id));
  const displayedMessages = useSelector((state) => state.snackbar.messages);
  const [queuedForRemoval, setQueuedForRemoval] = useState([]);

  useEffect(() => {
    [...messages, ...displayedMessages].forEach((msg) => {
      if (!queuedForRemoval.includes(msg.uid)) {
        if (!displayedMessages.find((currentMsg) => currentMsg.uid === msg.uid))
          dispatchSnackBarMessage(msg);
        setTimeout(() => dispatchSnackBarMessageRemove(msg.uid), snackbarTimeout);
        setQueuedForRemoval((queue) => queue.concat(msg.uid));
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [messages, displayedMessages]);

  // TODO: logic to display multiple messages at a time
  return displayedMessages.length ? (
    <Snackbar
      dataQa={dataQa}
      zIndex={zIndex}
      error={displayedMessages[0].type === 'error'}
      show
      message={displayedMessages[0].message}
    />
  ) : null;
};

SnackbarMgr.propTypes = {
  dataQa: PropTypes.string,
  messages: PropTypes.arrayOf(PropTypes.shape({})),
  zIndex: PropTypes.number
};

SnackbarMgr.defaultProps = {
  dataQa: 'snackbarContainer',
  messages: [],
  zIndex: 9999
};

export default SnackbarMgr;
